import React, { useState } from "react";
import { ReactComponent as LocationSvg } from '../../src/assets/images/location.svg'

const CareerPage = () => {

    const [backendExpand, setBackendExpand] = useState(false);
    const [embeddedInternExpand, setEmbeddedInternExpand] = useState(false);
    const backendOpenings = 1;
    const internOpenings = 2;

    const handleBackendExpand = () => {
        setBackendExpand(!backendExpand);
    }

    const handleEmbeddedInternExpand = () => {
        setEmbeddedInternExpand(!embeddedInternExpand)
    }

    const handleApplyClick = () => {
        const link = "https://www.linkedin.com/jobs/view/3682947488/";
        const target = "_blank";
        window.open(link, target);
    };

    return (<>
        <div className="flex justify-center items-center bg-careerBg w-full p-4 md:p-16">
            <div className="p-4 bg-contentBg border border-transparent rounded-2xl md:p-16">
                <div className="">
                    <div className="text-bold text-xl">Inspire Innovation: Become a Part of Our Driven and Dynamic Team</div>
                    <div className="py-8 text-textColor" >At Our Company, we are passionate about developing cutting-edge embedded products that shape the future of technology.
                        We take pride in our innovative solutions that address real-world challenges and drive industry advancements.
                        If you are someone who shares our enthusiasm for embedded systems and loves to create impactful products,
                        you've come to the right place!</div>
                </div>
                <div className="py-6">
                    <div className="text-bold text-xl pb-2">Open Roles</div>
                    <hr className="bg-textColor" />

                </div>
                <div>
                    <div
                        className="border border-borderColor hover:border-applyButtonColor rounded-xl mb-4 p-4 md:mb-8 md:p-8"
                        onClick={handleBackendExpand}
                    >
                        <div className="p-1 md:p-4">
                            <div className="text-bold">Backend Developer</div>
                            <p className="text-textColor text-xs md:text-sm ">We are looking for experienced backend developer to join our team</p>
                            <div className="py-1 md:flex md:justify-between">
                                <div className="flex">
                                    <div className="text-xs md:text-sm text-textColor border border-borderColor rounded-xl py-1 px-1 md:px-2  mr-2">
                                        Full-time
                                    </div>
                                    <div className="text-xs md:text-sm text-textColor border border-borderColor rounded-xl py-1 px-2 mr-2">
                                        On-site
                                    </div>
                                    <div className="text-xs hidden md:flex md:text-sm text-textColor border border-borderColor rounded-xl py-1 px-2">
                                        <LocationSvg className="h-4 w-4" />
                                        Chandigarh
                                    </div>
                                </div>
                                <div className="mt-2 md:mt-0 text-xs md:text-sm">Openings: {backendOpenings}</div>
                            </div>

                            {backendExpand && (<div className="py-2">
                                <div>Responsibilities</div>
                                <div>
                                    <ul className="hidden md:block md:text-sm">
                                        <li>Server-side Development: Design, develop, and maintain server-side applications and APIs to support front-end features and functionalities.</li>
                                        <li>Database Management: Manage databases, including designing schemas, optimizing queries, and ensuring data integrity.</li>
                                        <li>API Integration: Integrate with external services and APIs to enhance application capabilities.</li>
                                        <li>Security: Implement security measures to protect data and prevent vulnerabilities.</li>
                                        <li>Performance Optimization: Optimize server-side performance to ensure fast and efficient data processing.</li>
                                        <li>Testing and Debugging: Conduct thorough testing and debugging to identify and fix issues in the backend code.</li>
                                    </ul>
                                    <div className="md:hidden text-xs pb-2">
                                        <div className="pl-2">- Server-side Development: Design, develop, and maintain server-side applications and APIs to support front-end features and functionalities.</div>
                                        <div className="pl-2">- Database Management: Manage databases, including designing schemas, optimizing queries, and ensuring data integrity.</div>
                                        <div className="pl-2">- API Integration: Integrate with external services and APIs to enhance application capabilities.</div>
                                        <div className="pl-2">- Security: Implement security measures to protect data and prevent vulnerabilities.</div>
                                        <div className="pl-2">- Performance Optimization: Optimize server-side performance to ensure fast and efficient data processing.</div>
                                        <div className="pl-2">- Testing and Debugging: Conduct thorough testing and debugging to identify and fix issues in the backend code.</div>
                                    </div>
                                </div>
                                <div className="flex justify-center items-center" onClick={handleApplyClick}> <div className="w-auto border border-borderColor py-1 px-4 rounded-xl text-white bg-applyButtonColor">Click here to Apply </div></div>
                            </div>)}
                        </div>
                    </div>

                    <div
                        className="border border-borderColor hover:border-blue-300 hover:border-2 rounded-xl mb-4 p-4 md:mb-8 md:p-8"
                        onClick={handleEmbeddedInternExpand}
                    >
                        <div className="p-1 md:p-4">
                            <div className="text-bold">Embedded Developer Intern</div>
                            <p className="text-textColor text-xs md:text-sm">We are looking for experienced Embedded developer Intern to join our team</p>
                            <div className="py-1 md:flex md:justify-between">
                                <div className="flex">
                                    <div className="text-xs md:text-sm text-textColor border border-borderColor rounded-xl py-1 px-1 flex justify-center md:px-2 mr-2">
                                        Internship
                                    </div>
                                    <div className="text-xs md:text-sm text-textColor border border-borderColor rounded-xl py-1 px-1 md:px-2 mr-2">
                                        On-site
                                    </div>
                                    <div className="flex text-xs hidden md:flex md:text-sm text-textColor border border-borderColor rounded-xl py-1 px-2">
                                        <LocationSvg className="h-4 w-4" />
                                        Chandigarh
                                    </div>
                                </div>
                                <div className="mt-2 md:mt-0 text-xs md:text-sm">Openings: {internOpenings}</div>
                            </div>

                            {embeddedInternExpand && (<div className="py-2">
                                <div>Responsibilities</div>
                                <div>
                                    <ul className="hidden md:block md:text-sm">
                                        <li>Working on selecting electronic components for making circuits.</li>
                                        <li>Working on soldering components to PCB.</li>
                                        <li>Working on evaluating and writing the firmware for the common microcontrollers.</li>
                                        <li>Working on testing and troubleshooting circuits.</li>
                                    </ul>
                                    <div className="md:hidden text-xs pb-2">
                                        <div className="pl-2">- Working on selecting electronic components for making circuits.</div>
                                        <div className="pl-2">- Working on soldering components to PCB. </div>
                                        <div className="pl-2">- Working on evaluating and writing the firmware for the common microcontrollers.</div>
                                        <div className="pl-2">- Working on testing and troubleshooting circuits.</div>
                                    </div>
                                </div>
                                <div className="flex justify-center items-center" onClick={handleApplyClick}> <div className="w-auto border border-borderColor py-1 px-4 rounded-xl text-white bg-applyButtonColor">Click here to Apply </div></div>
                            </div>)}
                        </div>
                    </div>

                    <div className="py-2">
                        <div className="text-bold text-xl pb-2">How to Apply</div>
                        <hr className="bg-textColor" />
                    </div>
                    <div className="">
                        <p className="text-textColor">
                            Applicants can select the job opportunity from the list above to review the position.
                            Please click on the position that best suits your profile and carefully go through the responsibilities.
                            Afterward, click on the "Apply" button to proceed with your application.
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </>)
}

export default CareerPage